import './bootstrap';
import '../scss/app.scss';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';
import vuetify from "./vuetify";
import './Assets/fontawesome-pro-6.5.1-web/css/all.css';
import './Assets/fontawesome-pro-6.5.1-web/css/fontawesome.css';
import { VueReCaptcha } from 'vue-recaptcha-v3'

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHAV3_SITEKEY;

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(vuetify)
            .use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
